// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QZhR_","col":"styles_col__34jsp"};